import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoughagePlusEnvironment } from 'src/environments/environment';

import {
  ElasticApiResponse,
  ElasticLocation,
  ElasticQueryString,
} from './request-models/elastic-api.model';

@Injectable({
  providedIn: 'root',
})
export class ElasticApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<RoughagePlusEnvironment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/elastic/secure/';

  getLocations(query?: string): Observable<ElasticLocation[]> {
    return this.http
      .post<ElasticApiResponse<ElasticLocation>>(`${this.baseUrl}locations`, {
        size: 100,
        query: {
          bool: {
            should: [
              {
                bool: {
                  must_not: {
                    exists: {
                      field: 'IsDeleted',
                    },
                  },
                },
              },
              {
                term: {
                  IsDeleted: false,
                },
              },
            ],
            must: [
              { term: { 'Customer.Status': 2 } },
              ...(query
                ? [
                    {
                      multi_match: {
                        fields: [
                          ElasticQueryString.CustomerName,
                          ElasticQueryString.CustomerExternalId,
                          ElasticQueryString.EmailAddress,
                          ElasticQueryString.City,
                          ElasticQueryString.Country,
                          ElasticQueryString.PostalCode,
                          ElasticQueryString.Street,
                        ],
                        query: `*${query}*`,
                      },
                    },
                  ]
                : []),
            ],
          },
        },
      })
      .pipe(map(({ hits }) => hits.hits.map(({ _source }) => _source)));
  }
}
